import { render } from "./AssignUnAssignSupervisor.vue?vue&type=template&id=46ea68d6"
import script from "./AssignUnAssignSupervisor.vue?vue&type=script&lang=js"
export * from "./AssignUnAssignSupervisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__